@if (isListType) {
  <div style="width: fit-content">
    <sh-form-select
      [id]="id"
      [control]="mergeStrategyControl"
      [style]="formSelectStyle.Ghost"
      [options]="mergeStrategyOptions"
      [showEmptyOption]="false"
    ></sh-form-select>
  </div>
} @else {
  <p class="sh-merge-strategy-label">{{ "records.batch-edit.modify-to" | translate }}</p>
}

